import createAPI from './create-api';
export default createAPI(process.env.MUJI_APP_API_BASE);
